export default __webpack_public_path__ + "static/media/ic_simplenew.e2d751ee.svg";